export const iconFontAwesomeEditingEllipsisVertical = (
	<i className="fa-solid fa-ellipsis-vertical"></i>
);
